import { useSingleQueryStep } from '@monorepo/logs/src/contexts/SingleQueryStepContext';
import { SelectField } from '@monorepo/shared/componentsV2/fields/SelectField';
import { AggregationInterval } from 'mapistry-shared';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const ALL_TIME_VALUE = '';

// largest to smallest
const orderedIntervalOptions = [
  { label: 'All time', value: ALL_TIME_VALUE },
  { label: 'Year', value: AggregationInterval.YEAR },
  { label: 'Semi-Annual', value: AggregationInterval.SEMI_ANNUAL },
  { label: 'Quarter', value: AggregationInterval.QUARTER },
  { label: 'Month', value: AggregationInterval.MONTH },
  { label: 'Week', value: AggregationInterval.WEEK },
  { label: 'Day', value: AggregationInterval.DAY },
  { label: 'Hour', value: AggregationInterval.HOUR },
];

const StyledSelectField = styled(SelectField)`
  width: 15rem;
`;

export function AggregationIntervalSelect() {
  const { upstreamAggregationInterval } = useSingleQueryStep();
  const { dateColumn: dateColumnName, isLastStep } = useSingleQueryStep();

  // intervals can only stay the same or increase in size as aggregation steps are added (e.g. if a previous step specifies "quarter", then
  //  a following aggregation step must allow only "quarter", "year", and "all time")
  const availableIntervalOptions = useMemo(() => {
    // if there's no date column on which to do a interval aggregation, the only option is "All time"
    if (!dateColumnName) return orderedIntervalOptions.slice(0, 1);
    // If there is no aggregation upstream, all options are available for selection
    if (!upstreamAggregationInterval) return orderedIntervalOptions;

    const orderedIndexOfPreviousInterval = orderedIntervalOptions.findIndex(
      ({ value }) => value === upstreamAggregationInterval,
    );
    // include the largest previous interval,
    // a user might want to aggregate by it again but this time with different group-bys
    return orderedIntervalOptions.slice(0, orderedIndexOfPreviousInterval + 1);
  }, [dateColumnName, upstreamAggregationInterval]);

  return (
    <StyledSelectField
      disabled={!isLastStep}
      fullWidth={false}
      isLabelHidden
      label="Aggregation Period"
      name="interval"
      options={availableIntervalOptions}
    />
  );
}
